import { JSONSchemaType } from "ajv"
import validateConstant, {
  e入力パターン,
} from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TZyutyuHaisyaPatternPutReq } from "./TZyutyuHaisyaPattern"

type zyutyuHaisyaPatternPutReqRequires = Pick<
  TZyutyuHaisyaPatternPutReq,
  "受注配車パターンコード" | "荷主コード" | "受注部所コード"
> & {
  荷主請求ID: number | null
  荷主請求内訳ID: number | null
}

//TODO: 将来的に利用する
export const zyutyuHaisyaPatternPutReqRequiredSchema: JSONSchemaType<zyutyuHaisyaPatternPutReqRequires> =
  {
    type: "object",
    properties: {
      受注配車パターンコード: {
        type: "string",
        title: "受注配車パターンコード",
        minLength: 1,
        pattern: validateConstant.PATTERN.英数字のみ,
        maxLength: validateConstant.LENGTH.受注配車パターンコード,
        errorMessage: util.stringErrorMessage("受注配車パターンコード", {
          required: true,
          maxLength: validateConstant.LENGTH.受注配車パターンコード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
      荷主コード: {
        type: "string",
        title: "荷主コード",
        minLength: 1,
        maxLength: validateConstant.LENGTH.荷主コード,
        errorMessage: util.stringErrorMessage("荷主コード", {
          required: true,
          maxLength: validateConstant.LENGTH.荷主コード,
        }),
      },
      受注部所コード: {
        type: "string",
        title: "受注部所コード",
        minLength: 1,
        maxLength: validateConstant.LENGTH.部所コード,
        errorMessage: util.stringErrorMessage("受注部所コード", {
          required: true,
          maxLength: validateConstant.LENGTH.部所コード,
        }),
      },
      荷主請求ID: {
        type: "number",
        title: "荷主請求ID",
        minLength: 1,
        errorMessage: util.stringErrorMessage("表紙名", {
          required: true,
          minLength: 1,
        }),
      },
      荷主請求内訳ID: {
        type: "number",
        title: "荷主請求内訳ID",
        minLength: 1,
        errorMessage: util.stringErrorMessage("請求内訳", {
          required: true,
          minLength: 1,
        }),
      },
    },
    required: [
      "受注配車パターンコード",
      "荷主コード",
      "荷主請求ID",
      "受注部所コード",
      "荷主請求内訳ID",
    ],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        "受注配車パターンコード",
        "荷主コード",
        ["荷主請求ID", "表紙名"],
        ["荷主請求内訳ID", "請求内訳"],
        "受注部所コード",
      ]),
    },
  }
